import { useSelector } from "react-redux";

export const useAuth = () => {

    const { isAuthenticated, loading } = useSelector((state) => state.auth);

    return { auth: isAuthenticated, loading };

}